import Vue from 'vue'
import store from '../store'

const has = Vue.directive('has', {
  inserted: function (el, binding, vnode) {

    if(store.getters.userInfo.id != 1) {

      Vue.prototype.$roles = vnode.context.$route.meta.role

      const roles = vnode.context.$route.meta.role

      const value = binding.value

      if(!roles.includes(value)) {
        if(['detail', 'list'].includes(value)) {
          let child = el.firstChild
        
          while(child) {
            el.removeChild(child)
            child = el.firstChild
          }
        }else {
          el.remove()
        }
      }

    }
    
  }
})

export default has


// WEBPACK FOOTER //
// ./src/utils/v-has.js